export const processUrlInCaseFailOverIsRequired = (url: string): string => {
    if (process.env.NODE_ENV !== "production") return url;

    const gameUrl = new URLSearchParams(window.location.search).get("game_url");
    if (!gameUrl) return url;

    let host: string;
    try {
        host = new URL(gameUrl).host;
    } catch {
        return url; // invalid URL → fallback
    }

    const mainDomains = ["gamingcorpscasino.com", "cloudfront.net", "amazonaws.com", "localhost:3001"];


    // Extract base domain (e.g., gamingcorpscasino.com)
    const parts = host.split(".");
    const baseDomain = parts.slice(-2).join(".");

    console.warn(baseDomain);
    // If it's one of our main domains → no replacement needed
    if (mainDomains.includes(baseDomain)) return url;

    // Replace only the gamingcorpscasino.com part
    const updatedUrl = url.replace(/gamingcorpscasino\.com/g, baseDomain);

    console.warn("Failover applied:", updatedUrl);

    return updatedUrl;
};